import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { BadgeCopyComponent } from './rsabt-indicator-copy.component';
import { IndicatorState } from '../../../models/indicator.models';
import { IndicatorStates } from '../../../constants/indicators.constants';
import { TooltipDirective } from '../../atoms/tooltip/tooltip.directive';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { truncate } from '@ui';

@Component({
  selector: 'ui-administration-trafo-indicator',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BadgeCopyComponent, TooltipDirective, NzTagModule],
  template: `
    <div class="relative">
      <div class="flex flex-col gap-y-1">
        <div class="flex gap-x-2">
          <span
            uiTooltip
            [tooltipTitle]="nameTemplate"
            class="text-sm font-medium uppercase duration-300 transition-colors"
            [class]="stateClassMap[state()].label"
          >
            {{ truncatedName() }}
          </span>
        </div>
        <ui-badge-copy [id]="transformerId()!" [disabled]="isDisabled()" />
      </div>
    </div>

    <ng-template #nameTemplate>
      {{ name() }}
    </ng-template>
  `,
})
export class AdministrationTrafoIndicatorComponent {
  protected readonly TRUNCATE_MAX_CHARS: number = 72;

  state = input<IndicatorState>(IndicatorStates.Default);
  showCenterCode = input<boolean>(false);
  name = input.required<string>();
  distributorId = input.required<string>();
  transformerId = input.required<string>();
  rsabtId = input<string>();
  tsabtId = input<string>();
  vtnId = input<string>();

  isDisabled = computed(() => this.state() === IndicatorStates.Disabled);
  truncatedName = computed(() => {
    const maxChars = this.showCenterCode()
      ? this.TRUNCATE_MAX_CHARS
      : this.TRUNCATE_MAX_CHARS + 5;
    return truncate(this.name()!, maxChars);
  });

  stateClassMap: Record<IndicatorState, { code: string; label: string }> = {
    active: {
      code: 'text-black bg-[#D6E4FF]',
      label: 'cursor-pointer text-primary hover:text-tertiary',
    },
    disabled: { code: 'bg-neutral-1 text-neutral-6', label: 'text-neutral-6' },
    danger: {
      code: 'text-black bg-red-2',
      label: 'cursor-pointer text-error hover:text-black',
    },
  };
}
